// src/routes.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/pages/HomePage';
import LoginPage from './components/pages/LoginPage';
import RegisterPage from './components/pages/RegisterPage';
import ProfilePage from './components/pages/ProfilePage';
import BrowseRestaurantsPage from './components/pages/BrowseRestaurantsPage';
import MenuOrderPage from './components/pages/MenuOrderPage';
import OrderTrackingPage from './components/pages/OrderTrackingPage';
import NotificationsPage from './components/pages/NotificationsPage';
import OwnerDashboardPage from './components/pages/OwnerDashboardPage';
import RestaurantManagementPage from './components/pages/RestaurantManagementPage';
import MenuManagementPage from './components/pages/MenuManagementPage';
import OrderManagementPage from './components/pages/OrderManagementPage';
import AnalyticsRecommendationsPage from './components/pages/AnalyticsRecommendationsPage';
import PaymentPage from './components/pages/PaymentPage';
import TrackDeliveryPage from './components/pages/TrackDeliveryPage';
import ChatPage from './components/pages/ChatPage';
import ChatListPage from './components/pages/ChatListPage';
import DriverApp from './components/pages/DriverApp';
import { useAuth } from './hooks/useAuth';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

const OwnerRoute = ({ children }) => {
  const { user } = useAuth();
  return user && user.role === 'owner' ? children : <Navigate to="/payment" />;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      
      {/* Customer-specific routes */}
      <Route path="/browse-restaurants" element={<ProtectedRoute><BrowseRestaurantsPage /></ProtectedRoute>} />
      <Route path="/menu-order/:restaurantId" element={<ProtectedRoute><MenuOrderPage /></ProtectedRoute>} />
      <Route path="/order-tracking" element={<ProtectedRoute><OrderTrackingPage /></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
      <Route path="/track/:orderId" element={<ProtectedRoute><TrackDeliveryPage /></ProtectedRoute>} />
      <Route
  path="/chat/:orderId"
  element={<ProtectedRoute><ChatPage/></ProtectedRoute>}
/>
      <Route path="/driver/:orderId" element={<DriverApp />} />
      
      {/* Owner-specific routes */}
      <Route path="/owner/dashboard" element={<OwnerRoute><OwnerDashboardPage /></OwnerRoute>} />
      <Route path="/owner/restaurant-management" element={<OwnerRoute><RestaurantManagementPage /></OwnerRoute>} />
      <Route path="/owner/menu-management" element={<OwnerRoute><MenuManagementPage /></OwnerRoute>} />
      <Route path="/owner/order-management" element={<OwnerRoute><OrderManagementPage /></OwnerRoute>} />
      <Route path="/owner/analytics" element={<OwnerRoute><AnalyticsRecommendationsPage /></OwnerRoute>} />
      <Route
  path="/owner/chats"
  element={<OwnerRoute><ChatListPage/></OwnerRoute>}
/>
      
      {/* Payment route */}
      <Route path="/payment" element={<ProtectedRoute><PaymentPage /></ProtectedRoute>} />
      
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default AppRoutes;
